<template>
  <div class="container configure">
    <div class="header card">
      <el-breadcrumb
        class="breadcrumb"
        separator="/"
      >
        <el-breadcrumb-item>应用管理</el-breadcrumb-item>
        <el-breadcrumb-item>系统配置</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="content">
        <div class="left">
          <h2 class="title">系统配置</h2>
        </div>
      </div>
    </div>
    <div class="default card">
      <div class="title">默认参数</div>
      <div class="upload-item">
        <div class="left">
          <div class="upload-title">
            默认头像
          </div>
          <img
            class="default-avatar"
            :src="defaultAvatar"
            alt="avatar"
          >
        </div>
        <div class="action">
          <el-upload
            :action="imgUploadUrl"
            :headers="uploadHeaders"
            :show-file-list="false"
            :on-success="handleAvatarSuccess"
            :before-upload="handleAvatarBefore"
          >
            <el-button
              size="small"
              type="primary"
            >上传图片</el-button>
            <div
              slot="tip"
              class="el-upload__tip"
            >尺寸：140*140</div>
          </el-upload>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          考研时间
        </div>
        <div class="setting-value">
          <div class="value">
            <el-date-picker
              v-model="startTime"
              type="date"
              @change="haneleTimeChange($event, 'start')"
              placeholder="选择日期"
              style="width:175px;"
            >
            </el-date-picker>
          </div>
          <span>-</span>
          <div class="value">
            <el-date-picker
              v-model="endTime"
              type="date"
              @change="haneleTimeChange($event, 'end')"
              placeholder="选择日期"
              style="width:175px;"
            >
            </el-date-picker>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="saveTestDate"
            >更新时间</el-button>
          </div>
        </div>
      </div>
    </div>
    <div class="default flex-card card">
      <div class="title">App设置</div>
      <div class="setting-item">
        <div class="setting-head">
          版本号设置
        </div>
        <div class="setting-value">
          <div class="value">
            <el-input
              v-model="version_no"
              placeholder="输入版本号"
              style="width:370px;"
            ></el-input>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="saveVersion_no"
            >立即更新</el-button>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          build号
        </div>
        <div class="setting-value">
          <div class="value">
            <el-input
              v-model="build_no"
              placeholder="输入build号"
              style="width:370px;"
            ></el-input>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="saveBuild_no"
            >立即更新</el-button>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          下载链接
        </div>
        <div class="setting-value">
          <div class="value">
            <el-input
              v-model="download_url"
              placeholder="输入版本号"
              style="width:370px;"
            ></el-input>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="saveDownload_url"
            >立即更新</el-button>
          </div>
        </div>
      </div>

      <div class="setting-item">
        <div class="setting-head">
          APK上传地址
        </div>
        <div
          class="setting-value"
          style="height:100px;background:#fff;"
        >
          <div class="action">
            <!--    <el-button
              type="primary"
              @click="saveUpload_url"
            >立即更新</el-button> -->
            <el-upload
              :limit="1"
              :action="fileUploadUrl"
              :headers="uploadHeaders"
              :on-success="handleUploadSuccess"
              :file-list="fileList"
              :on-exceed="handleUploadOnExeed"
              :on-remove="handleUploadRemove"
            >
              <el-button
                size="mini"
                type="primary"
              >上传文件</el-button>
            </el-upload>
          </div>
          <div
            class="value"
            style="width:370px;"
          >
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          是否强制更新
          <div style="margin-top:24px;">
            <el-switch
              v-model="app_force_status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
              @change="saveApp_force_status"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          是否打开审核时商品屏蔽
          <div style="margin-top:24px;">
            <el-switch
              v-model="app_check_status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
              @change="saveApp_check_status"
            >
            </el-switch>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          学长感恩活动开始时间
        </div>
        <div class="setting-value">
          <div class="value">
            <el-date-picker
              v-model="senior_thank_startTime"
              type="datetime"
              style="width:370px;"
              placeholder="选择日期时间"
              value-format="timestamp"
            >
            </el-date-picker>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="saveThank_startTime"
            >立即更新</el-button>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          学长感恩活动结束时间
        </div>
        <div class="setting-value">
          <div class="value">
            <el-date-picker
              v-model="senior_thank_endTime"
              type="datetime"
              style="width:370px;"
              placeholder="选择日期时间"
              value-format="timestamp"
            >
            </el-date-picker>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="saveThank_endTime"
            >立即更新</el-button>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          学长感恩活动总金额
        </div>
        <div class="setting-value">
          <div class="value">
            <el-input
              v-model="senior_thank_total"
              placeholder="输入总金额"
              style="width:370px;"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="savethank_total"
            >立即更新</el-button>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          学长感恩活动剩余金额
        </div>
        <div class="setting-value">
          <div class="value">
            <el-input
              v-model="senior_thank_last"
              placeholder="输入剩余金额"
              style="width:370px;"
              oninput="value=value.replace(/[^0-9.]/g,'')"
            ></el-input>
          </div>
          <div class="action">
            <el-button
              type="primary"
              @click="savethank_last"
            >立即更新</el-button>
          </div>
        </div>
      </div>
      <div class="setting-item">
        <div class="setting-head">
          调剂QQ小程序是否审核
          <div style="margin-top:24px;">
            <el-switch
              v-model="qqmini_adjust_check_status"
              active-color="#13ce66"
              inactive-color="#ff4949"
              active-value="1"
              inactive-value="0"
              @change="saveQqmini_adjust_check_status"
            >
            </el-switch>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { imgUploadUrl, uploadHeaders, fileUploadUrl } from '@/config/index'
import { configureList, configureCreate, configureUpdate } from '@/api/operation'

export default {
  data() {
    return {
      imgUploadUrl: imgUploadUrl(),
      uploadHeaders: uploadHeaders(),
      fileUploadUrl: fileUploadUrl(),
      defaultAvatar: '',
      startTime: '',
      endTime: '',
      wechatCustomerService: '',
      configureList: [],
      version_no: '',
      build_no: '',
      download_url: '',
      app_check_status: '',
      app_force_status: "",
      fileList: [],
      senior_thank_startTime: "",
      senior_thank_endTime: "",
      senior_thank_total: 0,
      senior_thank_last: 0,
      qqmini_adjust_check_status: '',
    }
  },
  created() {
    this.fetchConfigureList()
  },
  methods: {
    // 配置列表查询
    fetchConfigureList() {
      configureList().then(res => {
        if (res) {
          this.configureList = res.list
          this.configureParse()
        }
      })
    },

    // 配置列表解析
    configureParse() {
      this.configureList.forEach(v => {
        // 考研时间
        if (v.code == 'TestDate') {
          const times = v.value.split(',')
          this.startTime = Number(times[0] || 0)
          this.endTime = Number(times[1] || 0)
        }
        // 默认头像
        if (v.code == 'DefaultAvatar') {
          this.defaultAvatar = v.value
        }
        // 微信客服号
        if (v.code == 'WechatCustomerService') {
          this.wechatCustomerService = v.value
        }
        // 版本号
        if (v.code == 'AppVersionNo') {
          this.version_no = v.value
        }
        // app 打包号
        if (v.code == 'AppBuildNo') {
          this.build_no = v.value
        }
        // app 下载链接
        if (v.code == 'AppDownloadUrl') {
          this.download_url = v.value
        }
        // app 审核状态
        if (v.code == 'AppCheckStatus') {
          this.app_check_status = v.value
        }
        // app 上传地址
        if (v.code == 'AppUploadUrl') {
          this.fileList = [JSON.parse(v.value)]
        }
        // app 强制更新状态
        if (v.code == 'AppForceStatus') {
          this.app_force_status = v.value
        }
        // 学长感恩活动开始时间
        if (v.code == 'SeniorThankStartTime') {
          this.senior_thank_startTime = Number(v.value)
        }
        // 学长感恩活动结束时间
        if (v.code == 'SeniorThankEndTime') {
          this.senior_thank_endTime = Number(v.value)
        }
        // 学长感恩活动总金额
        if (v.code == 'SeniorThankTotalAmount') {
          this.senior_thank_total = Number(v.value)
        }
        // 学长感恩活动剩余金额
        if (v.code == 'SeniorThankLastAmount') {
          this.senior_thank_last = Number(v.value)
        }
        // 调剂QQ小程序是否审核
        if (v.code == 'QQMiniAdjustCheckStatus') {
          this.qqmini_adjust_check_status = v.value
          
        }
      })
    },
    // 默认头像上传
    handleAvatarBefore(file) {
      const isLt2M = file.size / 1024 / 1024 < 5

      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 5MB!')
      }
      return isLt2M
    },
    // 默认头像上传
    handleAvatarSuccess(res, file) {
      if (res.code == 0 && res.data) {
        this.defaultAvatar = res.data.url
        const params = {
          code: 'DefaultAvatar',
          name: '默认头像',
          value: res.data.url
        }
        const one = this.configureList.find(v => v.code == 'DefaultAvatar')
        if (one) {
          configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
            this.$message.success('默认头像更新成功')
          })
        } else {
          configureCreate(params).then(res => {
            this.$message.success('默认头像添加成功')
          })
        }

      } else {
        this.$message.error(res.error)
      }
    },
    // 考研时间变更
    haneleTimeChange(value, type) {
      if (type == 'start') {
        this.startTime = this.$moment(value).valueOf()
      } else {
        this.endTime = this.$moment(value).valueOf()
      }
    },
    // 保存考研时间
    saveTestDate() {
      if (!this.startTime || !this.endTime) {
        this.$message.error('请选择日期')
        return
      }
      const params = {
        code: 'TestDate',
        name: '考研时间',
        value: this.startTime + ',' + this.endTime
      }
      const one = this.configureList.find(v => v.code == 'TestDate')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('考研日期更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('考研日期添加成功')
        })
      }
    },
    // 更新客服
    saveServices() {
      if (!this.wechatCustomerService) {
        this.$message.error('请输入客服微信号')
        return
      }
      const params = {
        code: 'WechatCustomerService',
        name: '微信客服',
        value: this.wechatCustomerService
      }
      const one = this.configureList.find(v => v.code == 'WechatCustomerService')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('微信客服号更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('微信客服号添加成功')
        })
      }
    },
    saveVersion_no() {
      if (!this.version_no) {
        this.$message.error('请输入版本号')
        return
      }
      const params = {
        code: 'AppVersionNo',
        name: 'app 版本号',
        value: this.version_no
      }
      const one = this.configureList.find(v => v.code == 'AppVersionNo')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('版本号更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('版本号添加成功')
        })
      }
    },
    saveBuild_no() {
      if (!this.build_no) {
        this.$message.error('请输入build号')
        return
      }
      const params = {
        code: 'AppBuildNo',
        name: 'app 打包号',
        value: this.build_no
      }
      const one = this.configureList.find(v => v.code == 'AppBuildNo')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('build号更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('build号添加成功')
        })
      }
    },
    saveDownload_url() {
      if (!this.download_url) {
        this.$message.error('请输入下载链接')
        return
      }
      const params = {
        code: 'AppDownloadUrl',
        name: 'app 下载地址',
        value: this.download_url
      }
      const one = this.configureList.find(v => v.code == 'AppDownloadUrl')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('下载链接更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('下载链接添加成功')
        })
      }
    },
    handleUploadSuccess(res, file) {
      this.fileList.push({
        name: file.name,
        url: file.response.data.url,
      })
      const params = {
        code: 'AppUploadUrl',
        name: 'app 上传地址',
        value: JSON.stringify(this.fileList[0])
      }
      const one = this.configureList.find(v => v.code == 'AppUploadUrl')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('上传地址更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('上传地址添加成功')
        })
      }
    },
    handleUploadOnExeed(files, fileList) {
      this.$message.error('上传地址已达到上限')
    },
    handleUploadRemove() {
      this.fileList = []
    },
    saveApp_check_status(e) {
      const params = {
        code: 'AppCheckStatus',
        name: 'app 审核状态',
        value: e
      }
      const one = this.configureList.find(v => v.code == 'AppCheckStatus')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('审核状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('审核状态添加成功')
        })
      }
    },
    saveApp_force_status(e) {
      const params = {
        code: 'AppForceStatus',
        name: 'app 强制更新状态',
        value: e
      }
      const one = this.configureList.find(v => v.code == 'AppForceStatus')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('强制更新状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('强制更新状态添加成功')
        })
      }
    },
    saveThank_startTime() {
      const params = {
        code: 'SeniorThankStartTime',
        name: '学长感恩活动开始时间',
        value: this.senior_thank_startTime.toString()
      }
      const one = this.configureList.find(v => v.code == 'SeniorThankStartTime')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('更新状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('更新状态添加成功')
        })
      }
    },
    saveThank_endTime() {
      const params = {
        code: 'SeniorThankEndTime',
        name: '学长感恩活动结束时间',
        value: this.senior_thank_endTime.toString()
      }
      const one = this.configureList.find(v => v.code == 'SeniorThankEndTime')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('更新状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('更新状态添加成功')
        })
      }
    },
    savethank_total() {
      const params = {
        code: 'SeniorThankTotalAmount',
        name: '学长感恩活动总金额',
        value: this.senior_thank_total.toString()
      }
      const one = this.configureList.find(v => v.code == 'SeniorThankTotalAmount')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('更新状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('更新状态添加成功')
        })
      }
    },
    savethank_last() {
      const params = {
        code: 'SeniorThankLastAmount',
        name: '学长感恩活动剩余金额',
        value: this.senior_thank_last.toString()
      }
      const one = this.configureList.find(v => v.code == 'SeniorThankLastAmount')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('更新状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('更新状态添加成功')
        })
      }
    },
    saveQqmini_adjust_check_status(e) {
      const params = {
        code: 'QQMiniAdjustCheckStatus',
        name: '调剂QQ小程序 审核状态',
        value: e
      }
      const one = this.configureList.find(v => v.code == 'QQMiniAdjustCheckStatus')
      if (one) {
        configureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
          this.$message.success('强制更新状态更新成功')
        })
      } else {
        configureCreate(params).then(res => {
          this.$message.success('强制更新状态添加成功')
        })
      }
    },
    saveAppConfig() {
      appconfigureUpdate(Object.assign({}, params, { id: one.id })).then(res => {
        this.$message.success('下载链接更新成功')
      })
    }
  }
};
</script>

<style scoped lang="less">
.configure {
  .card {
    position: relative;
    color: #303133;
    background-color: #fff;
    border: 1px solid #ebeef5;

    border-radius: 4px;
    overflow: hidden;
    padding: 24px;
  }
  .header {
    .breadcrumb {
      margin-bottom: 30px;
    }
    .title {
      font-size: 30px;
    }
    .content {
      display: flex;
      align-content: center;
    }

    .left,
    .right {
      flex: 1;
    }
    .right {
      display: flex;
      justify-content: flex-end;
      align-items: center;
      text-align: center;
    }
  }
  .default {
    margin-top: 20px;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    .title {
      padding-bottom: 24px;
      font-size: 20px;
      font-weight: 600;
      border-bottom: dashed 1px #e8e8e8;
      margin-bottom: 24px;
      width: 100%;
    }
    .upload-item {
      margin-right: 24px;
      display: flex;
      align-items: flex-end;
      margin-bottom: 24px;
      min-width: 540px;
      .upload-title {
        font-size: 16px;
        font-weight: 600;
        span {
          font-size: 14px;
          color: #999999;
          margin-left: 8px;
        }
      }
      .default-avatar {
        width: 96px;
        height: 96px;
        margin-top: 24px;
      }
      .action {
        margin-left: 24px;
        margin-bottom: 8px;
      }
    }
    .setting-item {
      display: flex;
      flex-direction: column;
      justify-content: center;
      min-width: 520px;
      min-height: 104px;

      .setting-head {
        font-size: 16px;
        font-weight: 600;
      }
      .setting-value {
        padding: 0px 24px;
        width: 520px;
        margin-top: 16px;
        height: 64px;
        background-color: #f5f5f5;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: space-around;
      }
    }
  }
  .flex-card {
    display: flex;
    flex-wrap: wrap;
    .setting-item {
      margin: 0px 16px;
      margin-bottom: 24px;
    }
  }
}
</style>
